export default __webpack_public_path__ + "static/media/power.66596e16.svg";